import { Pipe, PipeTransform } from "@angular/core";
import { shortNumber } from "../utilities/numbers";

@Pipe({
  name: "shortNumber",
})
export class ShortNumberPipe implements PipeTransform {
  transform(number: number, args?: any): any {
    return shortNumber(number);
  }
}
